import React, { useState } from 'react';
import {SignInView} from 'views/auth/SignIn';

import Authentication from "api/Authentication";
import UserModel from 'models/User';

import {
  MESSAGE_INFO,
  MESSAGE_ERROR,
  MESSAGE_SUCCES
} from "../../actions/types";
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';

class SignIn extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {error: null,isLoaded: false, user: new UserModel() , validation: false};
		this.dispatch = this.props.dispatch;

	}
  
	componentDidMount() {
//		const { dispatch, history } = this.props;
		//dispatch({ type: LOGIN_SUCCESS, payload: {} });
	}

	onSaveHandler = async (data) => {
		let isLoggedIn = await Authentication.signin(data);
		if(isLoggedIn && isLoggedIn.status != 200) {
			if(isLoggedIn.status == 406) {
				this.setState({validation: isLoggedIn.data.data.validation});		
				this.dispatch({ type: MESSAGE_INFO, "message": "In het formulier zijn validatie fouten gevonden!", "header": "Validatie fouten" });
			} else {
				this.dispatch({ type: MESSAGE_ERROR, "message": "Er is een onbekende fout opgetreden bij het versturen van het formulier.", "header": "Systeem error" });
			}
		} else  {
			this.dispatch({ type: MESSAGE_SUCCES, "message": "U bent succesvol geregsitreerd. Binnenkort ontvangt u een email met daarin de activatie link van u account.", "header": "Succesvolle registratie" });
			this.props.navigate('login');
		}
	}

	render() {
		const {user, validation } = this.state;
		return(

					<SignInView initData={user} onSave={this.onSaveHandler} validation={validation}/>
		);
	}
}

const SignInInit = (props) => {
	let navigate = useNavigate();
	//return (React.createElement(ComponentName, {...props, navigate:navigate, isLoggedIn: false}))
	//return (<Compo {...props} navigate={navigate}/>)
	return (<SignIn {...props} navigate={navigate}/>)
}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn,
  };
}

export default connect(mapStateToProps)(SignInInit);
/*
export default function Dashboard() {
	const api = new BaseAPI();  

api
      .getCategory()
      .then((response) => console.log(response))
      .catch((err) => console.log(err));
      
  return(
<Table striped bordered hover>
  <thead>
    <tr>
      <th>#</th>
      <th>First Name</th>
      <th>Last Name</th>
      <th>Username</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Mark</td>
      <td>Otto</td>
      <td>@mdo</td>
    </tr>
    <tr>
      <td>2</td>
      <td>Jacob</td>
      <td>Thornton</td>
      <td>@fat</td>
    </tr>
    <tr>
      <td>3</td>
      <td colSpan="2">Larry the Bird</td>
      <td>@twitter</td>
    </tr>
  </tbody>
</Table>    
  );
}
*/